import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import CheckBoxCard from '@/components/Form/CheckBoxCard';

// STYLES
import { TitleContainer, Title } from '../styles';

const variants = [
  {
    text: 'Netflix',
    imageSrc: getS3ImageUrl('/logos/services/netflix_t.svg'),
    value: 'netflix',
  },
  {
    text: 'Hulu',
    imageSrc: getS3ImageUrl('/logos/services/hulu_t.svg'),
    value: 'hulu',
  },
  {
    text: 'Amazon Prime',
    imageSrc: getS3ImageUrl('/logos/services/prime_t.png'),
    value: 'prime-video',
  },
  {
    text: 'Disney+',
    imageSrc: getS3ImageUrl('/logos/services/disney_logo.png'),
    value: 'disneyplus',
  },
];

const AlreadyHave = props => {
  const { t, values, handleChange, handleBlur, partner_data, onCheckboxChange, isRequired } = props;
  const textOverwrites = partner_data?.text_overwrites || {};

  const handleCheckboxChange = event => {
    onCheckboxChange(event, handleChange);
  };

  return (
    <>
      <TitleContainer className="form-title">
        <Title
          className={clsx(isRequired && 'required')}
          variant="h4"
          align="center"
          component="h1"
        >
          {textOverwrites.fmb_already_have_title || t('start.alreadyHave.title')}
        </Title>
        <Typography variant="subtitle1" align="center">
          {textOverwrites.fmb_already_have_subtitle || t('start.alreadyHave.subtitle')}
        </Typography>
      </TitleContainer>
      <Grid className="xs-start already-have" container spacing={1} justifyContent="center">
        {variants.map(item => (
          <Grid item xs={12} sm={3} md={3} key={item.value}>
            <CheckBoxCard
              name="already-have"
              value={item.value}
              imageSrc={item.imageSrc}
              handleChange={handleCheckboxChange}
              handleBlur={handleBlur}
              segmentText={item.text}
              checkedValue={values['already-have']}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

AlreadyHave.defaultPros = {
  isRequired: false,
};

AlreadyHave.propTypes = {
  t: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  partner_data: PropTypes.object,
  isRequired: PropTypes.bool,
};

export default withTranslation()(React.memo(AlreadyHave));
